import {MessageBox} from 'mint-ui'
import {WEB_USER_TOKEN} from '../../constants/LocalStorageKey'
import {USER_TOKEN_HEADER_NAME, DEVICE_ID_HEADER_NAME} from '../../constants/HttpParams'
let CordovaUtils = {
  currentTheme: ''
}
CordovaUtils.confirmExitApp = function () {
  MessageBox.confirm('确定退出CRM?', '').then(action => {
    if (action === 'confirm') {
      navigator.app.exitApp()
    }
  })
}
CordovaUtils.setExitFlag = function () {
  appExitFlag = true
  appExitCallback = this.confirmExitApp
}
CordovaUtils.clearExitFlag = function () {
  appExitFlag = false
}

CordovaUtils.setCustomBackHistory = function (fn) {
  customBackHistory = fn
}
CordovaUtils.setStatusBarTheme = function (theme) {
  if (this.currentTheme === theme) {
    return
  }
  this.currentTheme = theme
  try {
    if (window.plugins && window.plugins.StatusBarStyle) {
      window.plugins.StatusBarStyle.setStatusBarTheme(null, null, {theme: theme})
    }
  } catch (e) {
    console.error(e)
  }
}
/**
 * 获取图片并上传
 * @param options {sourceType: '图片来源 1相机 2相册', width: '图片宽度'， height: '图片高度', pictureType: '图片用途'}
 * @param success 上传成功的处理函数
 * @param fail 上传失败的处理函数
 */
CordovaUtils.takePictureThenUpload = function (options, success, fail) {
  if (window.plugins.CutPhoto) {
    let sourceType = parseInt(options.sourceType)
    let option = {
      outputX: options.width,
      outputY: options.height,
      pictureType: options.pictureType,
      success: success,
      fail: fail
    }
    if (sourceType === 2) {
      window.plugins.CutPhoto.openAlbum(CordovaUtils.onCameraSuccess, function (message) {
      }, option)
    } else {
      window.plugins.CutPhoto.openCamera(CordovaUtils.onCameraSuccess, function (message) {
      }, option)
    }
  }
}
CordovaUtils.onCameraSuccess = function (response, success, fail, pictureType) {
  if (FileUploadOptions) {
    let fileURL = response.imgUri
    let options = new FileUploadOptions()
    options.fileKey = 'file'
    options.fileName = fileURL.substr(fileURL.lastIndexOf('/') + 1)
    let deviceId = ''
    try {
      if (device) {
        deviceId = device.uuid
      }
    } catch (e) {
    }
    options.headers = {}
    options.headers[USER_TOKEN_HEADER_NAME] = window.localStorage.getItem(WEB_USER_TOKEN)
    options.headers[DEVICE_ID_HEADER_NAME] = deviceId
    let ft = new FileTransfer()
    // 上传图片 需要给出接口的全路径 这里要根据环境不同给出对应的url
    let location = window.location
    let domain = location.protocol + '//' + location.host
    let uploadUrl = domain + '/api/attachments/upload?pictureType=' + pictureType
    ft.upload(fileURL, uploadUrl, success, fail, options)
  }
}
/**
 * 如果是点击消息直接进入页面，无法回退，用这个方法来给一个默认跳转地址
 * @param toRoutePath
 * @param currentPath
 * @param router
 */
CordovaUtils.replacePathIfNoHistory = function (toRoutePath, currentPath, router) {
  window.setTimeout(function () {
    if (window.location.href === currentPath) {
      router.replace(toRoutePath)
    }
  }, 100)
}

CordovaUtils.getQueryParamValue = function (paramName) {
  let query = window.location.href.substring(window.location.href.indexOf('?') + 1)
  if (query.indexOf('#') > 0) {
    query = query.substring(0, query.indexOf('#'))
  }
  let vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=')
    if (pair[0] === paramName) {
      return pair[1]
    }
  }
  return null
}
export default CordovaUtils



// WEBPACK FOOTER //
// ./src/components/utils/CordovaUtils.js